import store from '../store';

export default class Repository {
    async get(path, query = {}, providerCode = true) {
        if (store.state.application.localEnv) {
            query.debug = 1;
        }
        const queryString = (new URLSearchParams(query)).toString();
        let url = `${store.state.application.apiRootUrl}/${path}`;
        if (queryString.length > 0) {
            url = `${url}?${queryString}`;
        }

        const headers = {};

        if (providerCode) {
            headers['x-provider-code'] = store.state.application.providerCode;
        }

        const response = await fetch(url, {
            headers,
            credentials: 'include'
        });

        if (response.status === 401) {
            store.commit('application/setSessionExpiredDialog', true);
        }

        return await response.json();
    }

    async post(path, body, json = true) {
        const url = `${store.state.application.apiRootUrl}/${path}`;

        const headers = {
            'x-provider-code': store.state.application.providerCode
        };

        if (json) {
            headers['Content-Type'] = 'application/json';
        }

        const response = await fetch(url, {
            method: 'POST',
            headers,
            credentials: 'include',
            body: json ? JSON.stringify(body) : body
        });

        if (response.status === 401) {
            store.commit('application/setSessionExpiredDialog', true);
        }

        return response.json();
    }

    async download(path, body, json = true) {
        const url = `${store.state.application.apiRootUrl}/${path}`;

        const headers = {
            'x-provider-code': store.state.application.providerCode
        };

        if (json) {
            headers['Content-Type'] = 'application/json';
        }

        const response = await fetch(url, {
            method: 'POST',
            headers,
            credentials: 'include',
            body: json ? JSON.stringify(body) : body
        });

        if (response.status === 401) {
            store.commit('application/setSessionExpiredDialog', true);
        }

        if (!response.ok) {
            throw new Error('Echec du téléchargement');
        }

        const blob = await response.blob();
        const downloadResultHeader = response.headers.get('X-Download-Result');        
        return {
            blob,
            headers: {
                'X-Download-Result': downloadResultHeader
            }
        };

    }

    async put(path, body) {
        const url = `${store.state.application.apiRootUrl}/${path}`;

        const headers = {
            'Content-Type': 'application/json',
            'x-provider-code': store.state.application.providerCode
        };

        const response = await fetch(url, {
            method: 'PUT',
            headers,
            credentials: 'include',
            body: JSON.stringify(body)
        });

        if (response.status === 401) {
            store.commit('application/setSessionExpiredDialog', true);
        }

        return response.json();
    }

    async delete(path) {
        const url = `${store.state.application.apiRootUrl}/${path}`;

        const headers = {
            'x-provider-code': store.state.application.providerCode
        };

        const response = await fetch(url, {
            method: 'DELETE',
            headers,
            credentials: 'include'
        });

        if (response.status === 401) {
            store.commit('application/setSessionExpiredDialog', true);
        }

        return response.json();
    }
}
